export const paths = {
    1: "/questionnaire",
    2: "/documents",
    3: "/submission",
    4: "/documents/step/3",
    5: "/applicant-rejected",
    6: "/hr-2nd-approval",
    7: "/submission/complete",
    8: "/submission/complete",
    9: "/submission/complete"
}